// src/components/ProductForm.jsx

import React, { useState } from 'react';
import { Button } from '@mui/material';
import GenericDropdown from './GenericDropdown';
import { PRODUCT_FIELDS } from '../constants'; // Import the product fields configuration

const ProductForm = ({ productTitle, onFormSubmit }) => {
  const [formData, setFormData] = useState({});

  // Retrieve field configuration for the selected product
  const { fields } = PRODUCT_FIELDS[productTitle];

  // Handle form field changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission and create the correct formData based on product
  const handleSubmit = (event) => {
    event.preventDefault();
  
    let updatedFormData = {};
    if (productTitle === "Ace with Mocks") {
      // Use `targetRole` and `targetCompany` for "Ace with Mocks"
      updatedFormData = {
        targetRole: formData.targetRole || '',  // Ensure empty string if field is blank
        targetCompany: formData.targetCompany || '',  // Ensure empty string if field is blank
      };
    } else if (productTitle === "Burnout to Break Free") {
      // Use `role` and `company` for "Burnout to Break Free"
      updatedFormData = {
        role: formData.role || '',
        company: formData.company || '',
      };
    }

    // Call onFormSubmit with the correct parameters based on product type
    if (productTitle === "Ace with Mocks") {
      onFormSubmit(productTitle, updatedFormData.targetRole, updatedFormData.targetCompany);
    } else if (productTitle === "Burnout to Break Free") {
      onFormSubmit(productTitle, updatedFormData.role, updatedFormData.company);
    }
  };

  return (
    <>
      {/* Form Rendering */}
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginRight: '12px'}}>
        {/* Render GenericDropdown dynamically based on product fields */}
        {fields.map(({ key, label, dataSource }) => (
          <GenericDropdown
            key={key}
            fieldKey={key}
            fieldLabel={label}
            value={formData[key] || ''}
            onChange={handleChange}
            data={dataSource}
            placeholder={label}
          />
        ))}

        {/* Submit Button */}
        <Button 
          type="submit" 
          fullWidth 
          variant="contained" 
          sx={{ 
            // fontFamily: 'Roboto',
            // fontWeight: 400,
            backgroundImage: 'linear-gradient(180deg, #F5973A 0%, #FFD23E 100%)', // Normal gradient
            color: '#04003F', // Text color
            textTransform: 'capitalize',
            height: '47px', 
            ml: '9px',
            mb: '10px',
            fontSize: '1.0rem',
            '&:hover': { 
              backgroundImage: 'linear-gradient(180deg, #ff870f 0%, #ffd102 100%)' // Darker gradient on hover
            },
          }}
        >  
          Submit
        </Button>
      </form>
    </>
  );
};

export default ProductForm;